(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('securityEventsList', ["path", "$q", "columnsHelper", "securityEventsDao", "timeResolutions", "securityEventStates", "securityEventTypes", "severityTypes", "modulesManager", "tablePaginationHelper", "defaultListConverter", "securityEventsConverters", "modals", "$timeout", "$location", "objectTypeDao", "downloadDetectedEntity", "apExceptionsModal", "appConfigurator", "troubleshooting", "rolesManager", "$rootScope", "anomalyExceptionsParams", "fileDao", "feature", "manualActionDao", "base64", "entityTypes", "secToolsExceptionParams", function (path, $q, columnsHelper, securityEventsDao, timeResolutions, securityEventStates, securityEventTypes, severityTypes, modulesManager, tablePaginationHelper, defaultListConverter, securityEventsConverters, modals, $timeout, $location, objectTypeDao, downloadDetectedEntity, apExceptionsModal, appConfigurator, troubleshooting, rolesManager, $rootScope, anomalyExceptionsParams, fileDao, feature, manualActionDao, base64, entityTypes, secToolsExceptionParams) {
        return {
            restrict: 'A',
            replace: false,
            templateUrl: path('gui-v2').directive('security-events/list').template('list'),
            scope: {
                resolution: '=',
                filters: '=',
                filterBy: '=',
                widgetApi: '=?api',
                secEventsApi: '=',
                secEntityNames: '=?'
            },
            link: function ($scope, element, attrs) {
                $scope.searchAfter = undefined;
                $scope.totalEvents = 0;
                var eventsUpdating = {};
                var aggregatedData = {};
                var availableActionsMap = {};
                $scope.filterActions = [];
                $scope.defaultPageSize = 20;
                if (feature.enableSecurityEventAggregation) {
                    $scope.defaultPageSize = 50;
                }
                // if(localStorage.getItem('pageSize-securityEvent')) {
                //     $scope.defaultPageSize = parseInt(localStorage.getItem('pageSize-securityEvent'));
                // }
                $scope.resolutionLabel = function () {
                    var found = timeResolutions.get($scope.resolution);
                    return found ? found.pastLabel : '';
                };
                $scope.variantLabel = function (type, variantId, tag) {
                    var button = _($scope.filterButtons).find(function (filterButton) {
                        return filterButton.id === type;
                    });
                    if (!button) {
                        return variantId;
                    }
                    var variants = button.variants;
                    if (tag && button.tags) {
                        variants = button.tags;
                    }
                    var found = _(variants).find(function (variant) {
                        return variant.id === variantId;
                    });
                    if (found) {
                        return found.label;
                    }
                    if (button.getUnknownLabel) {
                        return button.getUnknownLabel(variantId);
                    }
                    return variantId;
                };
                function reloadSecEventsApi(params) {
                    eventsUpdating = {};
                    aggregatedData = {};
                    availableActionsMap = {};
                    $scope.filterActions = [];
                    $scope.searchAfter = undefined;
                    $scope.secEventsApi.reload(params);
                }
                $scope.clearResolution = function () {
                    $scope.resolution = 'all';
                    reloadSecEventsApi();
                };
                $scope.clearAllFilters = function () {
                    $scope.resolution = 'all';
                    $scope.secEventsApi.clearAllFilters();
                };
                $scope.onFilterByChange = function () {
                    $timeout(function () {
                        reloadSecEventsApi();
                    });
                };
                var hidden_tools = [];
                if (Boolean(!feature.showClicktimeProtection)) {
                    hidden_tools.push('clicktime_protection_scan');
                }
                var tools = [];
                _(modulesManager.activeSecAppsFull()).each(function (app) {
                    if (!app.matrix_entity || hidden_tools.includes(app.matrix_entity)) {
                        return;
                    }
                    if (troubleshooting.entityDebugEnabled() || !app.gui_hidden) {
                        tools.push({
                            autoId: 'security_events_table_filter_tool_dropdown_item_' + app.matrix_entity,
                            id: app.matrix_entity,
                            label: app.label
                        });
                    }
                });
                // hide this due to limitation of child events aggregation
                // $scope.tablePageSize = {
                //     label: 'Page Size',
                //     id: 'page_size',
                //     'class': 'page-size',
                //     options: {
                //         autoId: 'security_events_table_page_size_dropdown',
                //         dropUpper: true
                //     },
                //     variants: [
                //         {
                //             autoId: 'security_events_table_page_size_dropdown_item_20',
                //             id: 20,
                //             label: '20'
                //         },
                //         {
                //             autoId: 'security_events_table_page_size_dropdown_item_50',
                //             id: 50,
                //             label: '50'
                //         },
                //         {
                //             autoId: 'security_events_table_page_size_dropdown_item_100',
                //             id: 100,
                //             label: '100'
                //         }
                //     ],
                //     onChange: function (value) {
                //         localStorage.setItem('pageSize-securityEvent', value);
                //         $scope.tableOptions.pageSize = value;
                //         $scope.tableOptions.pagination.pageSize = value;
                //     }
                // };
                $scope.filterButtons = [
                    {
                        label: 'Date',
                        id: 'create_time',
                        'class': 'filter-date',
                        variants: _(timeResolutions.dataPastLabel).filter(function (item) {
                            item.autoId = 'security_events_table_filter_date_dropdown_item_' + item.id;
                            return item.id !== 'minute';
                        }),
                        execute: function (variant) {
                            $scope.resolution = variant.removeAll ? 'all' : variant.id;
                            reloadSecEventsApi();
                        },
                        options: { autoId: 'security_events_table_filter_date_dropdown' }
                    },
                    {
                        label: 'State',
                        id: 'current_state',
                        'class': 'filter-state',
                        variants: securityEventStates.variants(),
                        skipAll: true,
                        type: 'selector',
                        options: {
                            autoId: 'security_events_table_filter_state_dropdown',
                            multiple: true,
                            emptyLabel: 'State',
                            showAll: false,
                            selectedLabelType: 'empty',
                            keepOpenOnLocation: true
                        },
                        onChange: function (values) {
                            $scope.secEventsApi.setFilter('current_state', values, false);
                        }
                    },
                    {
                        label: 'Type',
                        id: 'type',
                        'class': 'filter-type',
                        variants: angular.copy(securityEventTypes.data()),
                        skipAll: true,
                        type: 'selector',
                        options: {
                            autoId: 'security_events_table_filter_type_dropdown',
                            multiple: true,
                            emptyLabel: 'Type',
                            showAll: false,
                            selectedLabelType: 'empty',
                            keepOpenOnLocation: true
                        },
                        onChange: function (values) {
                            $scope.secEventsApi.setFilter('type', values, false);
                        }
                    },
                    {
                        label: 'Severity Level',
                        id: 'severity',
                        'class': 'filter-severity',
                        variants: [
                            {
                                autoId: 'security_events_table_filter_severity_dropdown_item_5',
                                id: 5,
                                label: 'Critical'
                            },
                            {
                                autoId: 'security_events_table_filter_severity_dropdown_item_4',
                                id: 4,
                                label: 'High'
                            },
                            {
                                autoId: 'security_events_table_filter_severity_dropdown_item_3',
                                id: 3,
                                label: 'Medium'
                            },
                            {
                                autoId: 'security_events_table_filter_severity_dropdown_item_2',
                                id: 2,
                                label: 'Low'
                            },
                            {
                                autoId: 'security_events_table_filter_severity_dropdown_item_1',
                                id: 1,
                                label: 'Lowest'
                            },
                            {
                                autoId: 'security_events_table_filter_severity_dropdown_item_all',
                                removeAll: true,
                                label: 'All'
                            }
                        ],
                        tags: angular.copy(severityTypes.data),
                        skipAll: true,
                        execute: function (variant) {
                            var button = this;
                            $scope.secEventsApi.updateFilter('severity', { removeAll: true }, true);
                            if (!variant.removeAll) {
                                _(button.tags).chain().filter(function (type) {
                                    return type.id >= variant.id;
                                }).each(function (type) {
                                    $scope.secEventsApi.updateFilter('severity', type, true);
                                });
                            }
                            reloadSecEventsApi();
                        },
                        options: { autoId: 'security_events_table_filter_severity_dropdown' }
                    },
                    {
                        label: 'SaaS',
                        id: 'saas',
                        'class': 'filter-saas',
                        variants: _(modulesManager.securityEventsSaasApps()).map(function (saas) {
                            return {
                                autoId: 'security_events_table_filter_saas_dropdown_item_' + saas.name,
                                id: saas.name,
                                label: saas.title
                            };
                        }),
                        getUnknownLabel: function (id) {
                            var app = modulesManager.app(id);
                            return app && app.label || id;
                        },
                        skipAll: true,
                        type: 'selector',
                        options: {
                            autoId: 'security_events_table_filter_saas_dropdown',
                            multiple: true,
                            emptyLabel: 'SaaS',
                            showAll: false,
                            selectedLabelType: 'empty',
                            keepOpenOnLocation: true
                        },
                        onChange: function (values) {
                            $scope.secEventsApi.setFilter('saas', values, false);
                        }
                    },
                    {
                        label: 'Tool',
                        id: 'matched_security_tool',
                        'class': 'filter-tool',
                        skipAll: true,
                        type: 'selector',
                        options: {
                            autoId: 'security_events_table_filter_tool_dropdown',
                            multiple: true,
                            emptyLabel: 'Tool',
                            showAll: false,
                            selectedLabelType: 'empty',
                            keepOpenOnLocation: true
                        },
                        variants: tools,
                        onChange: function (values) {
                            $scope.secEventsApi.setFilter('matched_security_tool', values, false);
                        }
                    }
                ];
                var filterButtonsMap = {};
                _($scope.filterButtons).each(function (button) {
                    filterButtonsMap[button.id] = button;
                    if (!button.skipAll) {
                        button.variants.unshift({
                            autoId: button.options.autoId + '_item_all',
                            removeAll: true,
                            label: 'All'
                        });
                    }
                    if (!button.execute) {
                        button.execute = function (variant) {
                            $scope.secEventsApi.updateFilter(button.id, variant);
                        };
                    }
                });
                $rootScope.$on('$selectAllClicked', function (event, state) {
                    var selectedEventsCount = $scope.tableHelper.getSelected().length;
                    if (state && selectedEventsCount < $scope.totalEvents) {
                        $scope.suggestAbsoluteSelection = true;
                    } else {
                        $scope.suggestAbsoluteSelection = false;
                        $scope.selectAbsoluteAllMode = false;
                    }
                });
                $scope.clearAbsoluteSelect = function () {
                    $scope.selectAbsoluteAllMode = false;
                };
                $scope.setAbsoluteSelect = function () {
                    $scope.selectAbsoluteAllMode = true;
                };
                function updateSelectorButtonFilters() {
                    _($scope.filterButtons).each(function (button) {
                        if (button.type === 'selector') {
                            button.value = [];
                        }
                    });
                    _($scope.filters).each(function (filter) {
                        if ($scope.secEntityNames && $scope.secEntityNames[filter.id]) {
                            filter.id = $scope.secEntityNames[filter.id];
                        }
                        var button = _($scope.filterButtons).find(function (filterButton) {
                            return filterButton.id === filter.type;
                        });
                        if (!button || button.type !== 'selector') {
                            return;
                        }
                        button.value.push(filter.id);
                    });
                }
                $scope.options = {
                    columns: [
                        {
                            id: 'sec_event_id',
                            hidden: true,
                            primary: true
                        },
                        {
                            id: 'create_time',
                            text: 'Time',
                            converter: 'doubleLineDate',
                            sortable: true
                        },
                        {
                            id: 'current_state',
                            text: 'State',
                            converter: 'stateConverter'
                        },
                        {
                            id: 'severity',
                            text: 'Severity',
                            dataClass: rolesManager.isActionAllowed([
                                'admin',
                                'user',
                                'operations'
                            ]) ? '' : ' no-click',
                            converter: 'severityConverter',
                            converterArgs: {
                                class: 'severity-inline-editor',
                                eventName: 'security-event-severity-change',
                                attributes: {
                                    eventId: 'sec_event_id',
                                    aggregation_id: 'aggregation_id'
                                }
                            },
                            sortable: true
                        },
                        {
                            id: 'saas',
                            text: 'SaaS',
                            converter: 'eventSaas',
                            dataClass: 'saas'
                        },
                        {
                            id: 'type',
                            text: 'Type',
                            converter: 'securityEventTypeConverter'
                        },
                        {
                            id: 'description',
                            text: 'Event Description',
                            class: 'wide-column',
                            dataClass: 'wide-column',
                            converter: 'descriptionConverter'
                        },
                        {
                            id: '_resolved.available_actions',
                            text: 'Actions',
                            converter: 'eventWorkflowConverter',
                            dataClass: 'workflow-cell',
                            hidden: rolesManager.isActionAllowed([
                                'admin',
                                'user',
                                'operations'
                            ]) ? false : true
                        },
                        {
                            id: '_resolved.history',
                            text: 'History',
                            converter: 'multiConverter',
                            converterArgs: {
                                converters: [
                                    {
                                        converter: 'historyArrayConverter',
                                        converterArgs: {
                                            field: 'create_time',
                                            reverse: true
                                        }
                                    },
                                    {
                                        converter: 'listConverter',
                                        converterArgs: {
                                            countPostfix: 'actions',
                                            collapseRest: true,
                                            moreInPopup: true,
                                            expanded: 4,
                                            itemConverter: 'historyItemConverter',
                                            itemConverterScope: 'element'
                                        }
                                    }
                                ]
                            }
                        },
                        {
                            id: '_resolved',
                            hidden: true
                        },
                        {
                            id: 'entity_id',
                            hidden: true
                        },
                        {
                            id: 'entity_type',
                            hidden: true
                        },
                        {
                            id: 'event_metadata',
                            hidden: true
                        },
                        {
                            id: 'matched_security_tool',
                            hidden: true
                        },
                        {
                            id: 'is_expandable',
                            hidden: true
                        },
                        {
                            id: 'child_events',
                            hidden: true
                        },
                        {
                            id: 'aggregation_id',
                            hidden: true
                        },
                        {
                            id: 'account_id',
                            hidden: true
                        }
                    ],
                    options: {
                        defaultOrdering: {
                            columnName: 'create_time,sec_event_id',
                            order: 'desc,desc'
                        },
                        constOrderingSuffix: [
                            {
                                columnName: 'create_time',
                                order: 'desc'
                            },
                            {
                                columnName: 'sec_event_id',
                                order: 'desc'
                            }
                        ],
                        checkboxes: rolesManager.isActionAllowed([
                            'admin',
                            'user',
                            'operations'
                        ]) ? true : false,
                        autoUpdate: 60000,
                        // Table data update timeout
                        expandable: true,
                        childSelectionOnParent: true
                    }
                };
                $scope.tableOptions = {
                    disableTop: true,
                    disableTotalRows: true,
                    orderDisplayMode: 'highlight-column',
                    asDivs: true,
                    infinite: true,
                    reloadUuid: true,
                    showWorkingIndicator: true,
                    workingIndicatorDisableGui: false,
                    saveState: true,
                    pagesAround: 2,
                    pagination: {
                        pageSize: $scope.defaultPageSize,
                        ordering: {}
                    },
                    dropdownHeader: true,
                    detectUIChange: true,
                    expandable: true,
                    childSelectionOnParent: true,
                    aggregationInfo: {
                        // these fix loadmore issue for aggregation table
                        actualDataSize: 0,
                        justAggregated: false,
                        totalSize: 0
                    }
                };
                var primaryColumn = columnsHelper.getPrimaryIdx($scope.options.columns);
                var childEventsColumnIdx = columnsHelper.getIdxByIdStrict($scope.options.columns, 'child_events');
                var actionsColumnIdx = columnsHelper.getIdxByIdStrict($scope.options.columns, '_resolved.available_actions');
                var securityToolColumnIdx = columnsHelper.getIdxByIdStrict($scope.options.columns, 'matched_security_tool');
                var aggregationIdColumnIdx = columnsHelper.getIdxByIdStrict($scope.options.columns, 'aggregation_id');
                var entityIdColumn = columnsHelper.getIdxByIdStrict($scope.options.columns, 'entity_id');
                var entityTypeColumn = columnsHelper.getIdxByIdStrict($scope.options.columns, 'entity_type');
                var accountIdColumn = columnsHelper.getIdxByIdStrict($scope.options.columns, 'account_id');
                var highlightEvent = $location.search().eventId || false;
                if (highlightEvent) {
                    highlightEvent = parseInt(highlightEvent);
                    if (isNaN(highlightEvent)) {
                        highlightEvent = false;
                    }
                    $location.search(_($location.search()).omit('eventId'));
                }
                function rowMatchesFilters(row) {
                    var filters = _($scope.filters).reduce(function (memo, filter) {
                        var type = filter.type;
                        memo[type] = memo[type] || [];
                        memo[type].push(filter.id);
                        return memo;
                    }, {});
                    return !_(filters).find(function (values, field) {
                        return !_(values).contains(row[field]);
                    });
                }
                /*
                * name: aggregation converter:
                * params:
                * @response (object)
                * */
                var aggregationConverter = function (response) {
                    $scope.tableOptions.aggregationInfo.justAggregated = false;
                    var originData = response && response.data && response.data.rows;
                    var newData = [];
                    if (originData) {
                        // let's init cached aggregated data when offset is 0
                        if (response.config && response.config.params && !response.config.params.offset) {
                            aggregatedData = {};
                            $scope.tableOptions.aggregationInfo.actualDataSize = 0;
                        }
                        if (originData.length) {
                            // save actual data size including children
                            $scope.tableOptions.aggregationInfo.actualDataSize += originData.length;
                            $scope.tableOptions.aggregationInfo.justAggregated = true;
                        }
                        _(originData).each(function (row, idx) {
                            if (row.aggregation_id) {
                                if (aggregatedData[row.aggregation_id]) {
                                    // check same parent event's children when loading new events
                                    if (aggregatedData[row.aggregation_id].length && _(aggregatedData[row.aggregation_id]).findIndex(function (r) {
                                            return r.sec_event_id === row.sec_event_id || r.sec_event_id === row.sec_event_id + '_parent';
                                        }) === -1 || !aggregatedData[row.aggregation_id].length && !$scope.tableModel || !aggregatedData[row.aggregation_id].length && $scope.tableModel && $scope.tableModel.data && _($scope.tableModel.data).findIndex(function (r) {
                                            return r[primaryColumn].originalText === row.sec_event_id;
                                        }) === -1) {
                                        aggregatedData[row.aggregation_id].push(row);
                                    }
                                } else {
                                    newData.push(row);
                                    aggregatedData[row.aggregation_id] = [];
                                }
                            } else {
                                newData.push(row);
                            }
                        });
                        _(newData).each(function (row, idx) {
                            if (row.aggregation_id) {
                                row.child_events = aggregatedData[row.aggregation_id];
                                if (row.child_events && row.child_events.length) {
                                    // add parent into dropdown list as dummy row
                                    var dummyRow = angular.copy(row);
                                    row.sec_event_id += '_parent';
                                    dummyRow.child_events = undefined;
                                    row.child_events.unshift(dummyRow);
                                }
                            }
                        });
                        return $q.when({ data: { rows: newData } });
                    }
                    return $q.when(response);
                };
                /*
                 * name: aggregationParentActionConverter:
                 * parent element should have all possible actions of its children.
                 * params:
                 * @response (object)
                 * */
                var aggregationParentActionConverter = function (response) {
                    if (rolesManager.isActionAllowed([
                            'admin',
                            'user',
                            'operations'
                        ])) {
                        _(response.data.data).each(function (row) {
                            var childEvents = row[childEventsColumnIdx].originalText;
                            if (childEvents && childEvents.length) {
                                var availableChildActions = {};
                                var parentActions = '';
                                _(childEvents).each(function (childRow) {
                                    var actionColumn = childRow._resolved && childRow._resolved.available_actions;
                                    var secTool = childRow.matched_security_tool;
                                    var actionGroup = securityEventsConverters.getAvailableActions(actionColumn, secTool);
                                    _(actionGroup).each(function (action, actionId) {
                                        if (!availableChildActions[actionId]) {
                                            availableChildActions[actionId] = {
                                                display: 'text',
                                                class: 'action-link',
                                                text: action.label,
                                                style: { display: 'block' },
                                                clickEvent: {
                                                    name: 'event-action',
                                                    eventId: row[primaryColumn].originalText,
                                                    actionId: action.actionId,
                                                    action: action,
                                                    eventData: {
                                                        aggregation_id: row[aggregationIdColumnIdx].originalText,
                                                        child_events: childEvents,
                                                        availableIds: [childRow.sec_event_id]
                                                    }
                                                }
                                            };
                                        } else {
                                            availableChildActions[actionId].clickEvent.eventData.availableIds.push(childRow.sec_event_id);
                                        }
                                    });
                                });
                                _(availableChildActions).each(function (action) {
                                    parentActions += ' #' + JSON.stringify(action);
                                });
                                row[actionsColumnIdx].text = parentActions;
                            }
                        });
                    }
                    return $q.when(response);
                };
                // ----------------
                // filter actions:
                // ----------------
                var getAvailableActions = function (line, actionsMap, newActions) {
                    var actionColumn = line[actionsColumnIdx];
                    var secTool = line[securityToolColumnIdx].text;
                    var actionGroup = securityEventsConverters.getAvailableActions(actionColumn.originalText, secTool);
                    _(actionGroup).each(function (action, actionId) {
                        if (!actionsMap[actionId]) {
                            actionsMap[actionId] = action;
                            newActions.push(action);
                        }
                    });
                };
                var generateFilterActions = function (actionsList) {
                    if (!actionsList || !actionsList.length) {
                        return;
                    }
                    actionsList.forEach(function (action) {
                        $scope.filterActions.push({
                            autoId: 'security_events_table_filter_actions_dropdown_item_' + action.id,
                            label: action.label,
                            enabled: function () {
                                return true;
                            },
                            execute: function () {
                                if (!$scope.totalEvents) {
                                    return;
                                }
                                var eventCount = function (count) {
                                    return count + ' event' + (count > 1 ? 's' : '');
                                };
                                var confirmMsg = 'Are you sure you want to perform "' + action.label + '" for the current filter scope? It might take some times to update.';
                                modals.confirm({ message: confirmMsg }).then(function () {
                                    $scope.tableHelper.clearSelection();
                                    return performActionOnFilteredEvents(action.actionId);
                                });
                            }
                        });
                    });
                };
                var getAvailableActionsFromData = function (response) {
                    if (rolesManager.isActionAllowed([
                            'admin',
                            'user',
                            'operations'
                        ])) {
                        var newActions = [];
                        _(response.data.data).each(function (line) {
                            getAvailableActions(line, availableActionsMap, newActions);
                        });
                        generateFilterActions(newActions);
                    }
                    return $q.when(response);
                };
                $scope.defaultListConverterArgs = {};
                var totalRowsTimeout;
                $scope.tableHelper = tablePaginationHelper($scope, $scope.tableOptions, $scope.options, {
                    isExpandable: function (row) {
                        return row && row.length && childEventsColumnIdx && row[childEventsColumnIdx].originalText && row[childEventsColumnIdx].originalText.length;
                    },
                    expand: function (row, filter) {
                        if (row && row.length) {
                            var childEvents = row[childEventsColumnIdx].originalText;
                            return defaultListConverter({ data: { rows: childEvents } }, $scope.defaultListConverterArgs);
                        }
                        return $q.when({});
                    },
                    getSubRows: function (row) {
                        if (row && row.length) {
                            var childEvents = row[childEventsColumnIdx].originalText;
                            var subRowsArgs = { noPromise: true };
                            $.extend(subRowsArgs, $scope.defaultListConverterArgs);
                            return defaultListConverter({ data: { rows: childEvents } }, subRowsArgs);
                        }
                        return [];
                    },
                    retrieve: function (args) {
                        updateSelectorButtonFilters();
                        var params = {
                            resolve: true,
                            filterBy: $scope.filterBy
                        };
                        params = _.extend(params, _($scope.filters).chain().reduce(function (memo, filter) {
                            var type = 'filterEnum_' + filter.type;
                            memo[type] = memo[type] || [];
                            memo[type].push(filter.id);
                            return memo;
                        }, {}).mapObject(function (val) {
                            return val.join(',');
                        }).value());
                        if (timeResolutions.get($scope.resolution)) {
                            params = _.extend(params, {
                                afterColumn: 'create_time',
                                afterStep: $scope.resolution,
                                afterFromNow: true,
                                afterMax: 1
                            });
                        }
                        $scope.currentFilterParams = params;
                        var result;
                        if (feature.enableSecurityEventsGQM && false) {
                            var isReloadEvents = !args.offset;
                            var searchAfter = isReloadEvents ? undefined : $scope.searchAfter;
                            var size = isReloadEvents ? args.limit : undefined;
                            result = feature.enableSecurityEventAggregation ? securityEventsDao.list_aggregated_es(searchAfter, size) : securityEventsDao.list_es(searchAfter);
                            result = result.after(function (res) {
                                $scope.totalEvents = res.data && res.data.total_rows ? res.data.total_rows : 0;
                                $scope.tableOptions.aggregationInfo.totalSize = $scope.totalEvents;
                                var lastRow = _.last(res.data.rows);
                                if (lastRow) {
                                    $scope.searchAfter = lastRow._sort;
                                }
                            });
                        } else {
                            var timeoutGetTotal = $q.defer();
                            var getTotalDefer;
                            if (feature.enableSecurityEventAggregation) {
                                getTotalDefer = securityEventsDao.list_aggregated();
                                result = securityEventsDao.list_aggregated();
                            } else {
                                getTotalDefer = securityEventsDao.list();
                                result = securityEventsDao.list();
                            }
                            getTotalDefer.timeout(timeoutGetTotal.promise).params(params).pagination(0, 1).then(function (res) {
                                $scope.totalEvents = res.data && res.data.total_rows ? res.data.total_rows : 0;
                                $scope.tableOptions.aggregationInfo.totalSize = $scope.totalEvents;
                            }).catch(function () {
                                $scope.totalEvents = 'Many';
                            }).finally(function () {
                                $timeout.cancel(totalRowsTimeout);
                            });
                            totalRowsTimeout = $timeout(function () {
                                timeoutGetTotal.resolve();
                            }, 10000);
                        }
                        result.preFetch(objectTypeDao.entities(), 'objectTypes').preFetch(securityEventsDao.getModuleConfigs(), 'moduleConfigs').params(_.extend(params, { no_return_rowscount: true }));
                        return result.pagination(args.offset, args.limit).order(args.ordering.columnName, args.ordering.order).converter(aggregationConverter).converter(defaultListConverter, function (preFetches) {
                            $scope.defaultListConverterArgs = {
                                columns: _($scope.options.columns).map(function (column) {
                                    if (column.converter == 'descriptionConverter') {
                                        column.converterArgs = column.converterArgs || {};
                                        column.converterArgs.objectTypes = preFetches.objectTypes;
                                    }
                                    if (column.converter == 'eventWorkflowConverter') {
                                        column.converterArgs = column.converterArgs || {};
                                        column.converterArgs.moduleConfigs = preFetches.moduleConfigs;
                                    }
                                    return column;
                                }),
                                converters: securityEventsConverters
                            };
                            return $scope.defaultListConverterArgs;
                        }).converter(aggregationParentActionConverter).converter(getAvailableActionsFromData);
                    }
                }, function (tableModel) {
                    $scope.tableModel = tableModel;
                    updateRowClasses();
                });
                $scope.groupActions = [{
                        autoId: 'security_events_table_group_actions_dropdown_item_no_events',
                        label: 'No events selected',
                        enabled: function () {
                            return false;
                        }
                    }];
                var correctAction = function (action, entityType) {
                    var correctedAction = { name: action.actionId };
                    if (action && action.data && action.data.name) {
                        correctedAction = angular.copy(action.data);
                        if (correctedAction.attributes && correctedAction.attributes.entity_type && correctedAction.tags) {
                            _(correctedAction.tags).each(function (val, key) {
                                if (correctedAction.attributes.entity_type === '{' + key + '}' && entityType !== val) {
                                    correctedAction.tags[key] = entityType;
                                }
                            });
                        }
                    }
                    return correctedAction;
                };
                /*
                * perform action for multiple events
                * */
                var performActionOnMultiple = function (value, isParent, selectedChildIds) {
                    var selectedEventIds = selectedChildIds || [];
                    if (!isParent && !selectedChildIds) {
                        _($scope.tableModel.selected).each(function (line) {
                            var actionColumn = line[actionsColumnIdx];
                            var selectedId = line[primaryColumn].originalText;
                            if (selectedId && selectedId.indexOf('_parent') === -1 && actionColumn.originalText.hasOwnProperty(value.actionId)) {
                                selectedEventIds.push(selectedId);
                            }
                        });
                    }
                    if (!selectedEventIds || !selectedEventIds.length) {
                        return;
                    }
                    var cfmMsg = '';
                    var prefix = selectedEventIds.length > 1 ? 's' : '';
                    if (value.actionId === 'quarantine_email') {
                        cfmMsg = 'Are you sure you want to perform quarantine on ' + selectedEventIds.length + ' email' + prefix + '?';
                    } else if (value.actionId === 'quarantine_file') {
                        cfmMsg = 'Are you sure you want to perform quarantine on ' + selectedEventIds.length + ' file' + prefix + '?';
                    } else {
                        cfmMsg = 'Are you sure you want to perform ' + value.label + ' on ' + selectedEventIds.length + ' event' + prefix + '?';
                    }
                    cfmMsg += ' this may take up to few minutes.';
                    modals.confirm({ message: cfmMsg }).then(function () {
                        $scope.tableOptions.loading = true;
                        // get entity_ids and entity_types for manual action api
                        var entityTypesCache = {};
                        if (!isParent) {
                            // for multiselection
                            _($scope.tableModel.selected).each(function (line) {
                                var selectedId = line[primaryColumn].originalText;
                                if (selectedId && _(selectedEventIds).findIndex(function (id) {
                                        return selectedId === id;
                                    }) !== -1) {
                                    var entityType = line[entityTypeColumn].originalText;
                                    if (entityTypesCache[entityType]) {
                                        if (_(entityTypesCache[entityType].recipientPlusEntities).findIndex(function (recipientPlusEntity) {
                                                return recipientPlusEntity === line[accountIdColumn].originalText + line[entityIdColumn].originalText;
                                            }) === -1) {
                                            entityTypesCache[entityType].entityIds.push(line[entityIdColumn].originalText);
                                            entityTypesCache[entityType].secEventIds.push(selectedId);
                                            entityTypesCache[entityType].recipientPlusEntities.push(line[accountIdColumn].originalText + line[entityIdColumn].originalText);
                                        } else {
                                            entityTypesCache[entityType].secEventIds.push(selectedId);
                                        }
                                    } else {
                                        entityTypesCache[entityType] = {
                                            entityIds: [line[entityIdColumn].originalText],
                                            secEventIds: [selectedId],
                                            recipientPlusEntities: [line[accountIdColumn].originalText + line[entityIdColumn].originalText]    // recipient + entity_id
                                        };
                                    }
                                }
                            });
                        } else {
                            // for child events on parent action
                            _($scope.tableModel.data).each(function (line) {
                                var selectedId = line[primaryColumn].originalText;
                                if (selectedId && _(selectedEventIds).findIndex(function (id) {
                                        return selectedId === id + '_parent';
                                    }) !== -1) {
                                    var childRows = line[childEventsColumnIdx].originalText;
                                    _(childRows).each(function (row) {
                                        if (row.sec_event_id && _(selectedEventIds).findIndex(function (id) {
                                                return row.sec_event_id === id;
                                            }) !== -1) {
                                            var entityType = row.entity_type;
                                            if (entityTypesCache[entityType]) {
                                                if (_(entityTypesCache[entityType].recipientPlusEntities).findIndex(function (recipientPlusEntity) {
                                                        return recipientPlusEntity === row.account_id + row.entity_id;
                                                    }) === -1) {
                                                    entityTypesCache[entityType].entityIds.push(row.entity_id);
                                                    entityTypesCache[entityType].secEventIds.push(row.sec_event_id);
                                                    entityTypesCache[entityType].recipientPlusEntities.push(row.account_id + row.entity_id);
                                                } else {
                                                    entityTypesCache[entityType].secEventIds.push(row.sec_event_id);
                                                }
                                            } else {
                                                entityTypesCache[entityType] = {
                                                    entityIds: [row.entity_id],
                                                    secEventIds: [row.sec_event_id],
                                                    recipientPlusEntities: [row.account_id + row.entity_id]    // recipient + entity_id
                                                };
                                            }
                                        }
                                    });
                                }
                            });
                        }
                        $scope.tableHelper.clearSelection();
                        $q.allSettled(_(entityTypesCache).map(function (ids, entityType) {
                            var passAbleAction = correctAction(value, entityType);
                            return manualActionDao.create(entityType, ids.entityIds, passAbleAction, ids.secEventIds, true);
                        })).then(function () {
                            // $scope.widgetApi.reload();
                            reloadSecEventsApi({ list: true });
                        });
                    });
                };
                $scope.$watchCollection(function () {
                    return $scope.tableHelper.getSelectedIds();
                }, function (newVal, oldVal) {
                    if (newVal.length === 0) {
                        $scope.groupActions = [{
                                autoId: 'security_events_table_group_actions_dropdown_item_no_events',
                                label: 'No events selected',
                                enabled: function () {
                                    return false;
                                }
                            }];
                    } else {
                        $scope.groupActions = [];
                        var availableActionGroup = {};
                        _($scope.tableModel.selected).each(function (line) {
                            getAvailableActions(line, availableActionGroup, []);
                        });
                        _(availableActionGroup).each(function (value) {
                            $scope.groupActions.push({
                                autoId: 'security_events_table_group_actions_dropdown_item_' + value.actionId,
                                label: value.label,
                                enabled: function () {
                                    return true;
                                },
                                execute: function () {
                                    performActionOnMultiple(value);
                                }
                            });
                        });
                    }
                    $scope.groupActions = rolesManager.isActionAllowed([
                        'admin',
                        'user',
                        'operations'
                    ]) ? $scope.groupActions : [];
                });
                function updateEventInline(response, removeOnly) {
                    // response: The updated event data
                    var keepRow = rowMatchesFilters(response.data);
                    // Convert the updated event data to table row.
                    return defaultListConverter({ data: { rows: [response.data] } }, {
                        columns: $scope.options.columns,
                        converters: securityEventsConverters
                    }).then(function (data) {
                        var newRow = data.data.data[0];
                        // Read the converted event data to table row.
                        var foundIndex = _($scope.tableModel.data).findIndex(function (row) {
                            // Find the event row by event id (primaryColumn).
                            return row[primaryColumn].originalText === newRow[primaryColumn].originalText;
                        });
                        if (foundIndex > -1) {
                            // Check if filter out the event row after action by matched filters
                            if (keepRow) {
                                if (!removeOnly) {
                                    $scope.tableModel.data[foundIndex] = newRow;    // Replace the event row with updated one.
                                }
                            } else {
                                $scope.tableModel.data.splice(foundIndex, 1);    // Remove the event row from the table.
                            }
                        }
                    });
                }
                function setEventRowActionPending(eventIds, isPending) {
                    if (!eventIds) {
                        return;
                    }
                    eventIds.forEach(function (eventId) {
                        eventsUpdating[eventId] = isPending;
                    });
                    updateRowClasses();
                }
                function getActionHistoryInfo(actionId) {
                    var mapActionsInfo = {
                        move_to_spam: 'Moved to Spam',
                        quarantine_email: 'Email quarantined',
                        restore_email: 'Email released',
                        phishing_found_event: 'User alerted',
                        remove_file: 'File removed',
                        quarantine_file: 'File quarantined',
                        restore_file: 'File released',
                        send_email_to_owner_malware: 'Owner alerted'
                    };
                    if (!mapActionsInfo[actionId]) {
                        return;
                    }
                    return {
                        tooltip: '',
                        label: mapActionsInfo[actionId],
                        create_time: new Date().toGMTString(),
                        error: false,
                        type: 'linked-text',
                        id: actionId
                    };
                }
                function getAdditionalActions(actionId, eventEntityType) {
                    var mapActionsAfter = {
                        quarantine_email: {
                            actionId: 'restore_email',
                            actionData: {
                                base_action: 'quarantine_email',
                                data: {
                                    attributes: { email: '{tag1}' },
                                    name: eventEntityType + '_restore',
                                    tags: { tag1: eventEntityType }
                                },
                                debug_only: null,
                                label: 'Release email',
                                log_action: true,
                                order: 0
                            }
                        },
                        quarantine_file: {
                            actionId: 'restore_file',
                            actionData: {
                                base_action: 'quarantine_file',
                                data: {
                                    attributes: { file: '{tag1}' },
                                    name: 'google_quarantine_restore',
                                    tags: { tag1: eventEntityType }
                                },
                                debug_only: null,
                                label: 'Release file',
                                log_action: true,
                                order: 0
                            }
                        }
                    };
                    return mapActionsAfter[actionId];
                }
                function getUpdatedEventState(actionEventState) {
                    if (!actionEventState) {
                        return;
                    }
                    var mapStates = {
                        dismiss: 'dismissed',
                        remediate: 'remediated'
                    };
                    return mapStates[actionEventState] || actionEventState;
                }
                function mapActionResultForSecurityEvent(securityEvent, actionId) {
                    var actionData = securityEvent._resolved.available_actions[actionId];
                    if (!actionData) {
                        return;
                    }
                    securityEvent.current_state = getUpdatedEventState(actionData.state_change) || securityEvent.current_state;
                    var actionHistoryInfo = getActionHistoryInfo(actionId);
                    var addActionAfter = getAdditionalActions(actionId, securityEvent.entity_type);
                    if (actionHistoryInfo) {
                        securityEvent._resolved.history.push(actionHistoryInfo);
                    }
                    if (addActionAfter) {
                        securityEvent._resolved.available_actions[addActionAfter.actionId] = addActionAfter.actionData;
                    }
                    delete securityEvent._resolved.available_actions[actionId];
                }
                function performSingleEventActionGQM(eventId, actionId, data) {
                    setEventRowActionPending([eventId], true);
                    return securityEventsDao.action(eventId, actionId).then(function () {
                        mapActionResultForSecurityEvent(data.eventRaw, actionId);
                        updateEventInline({ data: data.eventRaw });
                        return;
                    }).finally(function () {
                        setEventRowActionPending([eventId], false);
                    });
                }
                function performSingleEventAction(eventId, actionId, data) {
                    // Applay the selected action on event row
                    if (data && data.eventData && data.eventData.aggregation_id) {
                        return securityEventsDao.action(eventId, actionId).then(function () {
                            $scope.widgetApi.reload();    // Reload all events.
                        });
                    }
                    eventsUpdating[eventId] = true;
                    // Display pending spinner on event row.
                    updateRowClasses();
                    return securityEventsDao.action(eventId, actionId).then(function (response) {
                        return updateEventInline(response);
                    }).finally(function () {
                        eventsUpdating[eventId] = false;
                        updateRowClasses();
                    });
                }
                function performSelectedChildrenOnParentAction(eventId, actionId, data) {
                    var applyEventAction = feature.enableSecurityEventsGQM ? performSingleEventActionGQM : performSingleEventAction;
                    // When click on event action, check if required to display confirm modal before....
                    if (data && data.eventData && data.eventData.child_events && data.eventData.availableIds && data.eventData.availableIds.length) {
                        return performActionOnMultiple(data.action, true, data.eventData.availableIds);
                    }
                    var confirmModalOption = {};
                    if (actionId.indexOf('quarantine') !== -1) {
                        confirmModalOption = {
                            hasConfirm: true,
                            title: 'Attention - quarantine action',
                            msg: 'You are about to quarantine this item, are you sure you want to continue?'
                        };
                    } else if (actionId.indexOf('dismiss') !== -1) {
                        confirmModalOption = {
                            hasConfirm: true,
                            title: 'Attention - dismiss action',
                            msg: 'Are you sure you want to dismiss this event?'
                        };
                    }
                    if (confirmModalOption.hasConfirm) {
                        return modals.confirm({
                            title: confirmModalOption.title,
                            message: confirmModalOption.msg,
                            okText: 'Yes',
                            cancelText: 'No'
                        }).then(function () {
                            return applyEventAction(eventId, actionId, data);
                        });
                    }
                    applyEventAction(eventId, actionId, data);
                }
                function performActionOnFilteredEvents(actionId) {
                    return securityEventsDao.filterAction(actionId, $scope.currentFilterParams).then(function (response) {
                        $scope.suggestAbsoluteSelection = false;
                        $scope.selectAbsoluteAllMode = false;
                    }).finally(function () {
                        reloadSecEventsApi();
                    });
                }
                function updateVisualSeverity(eventId, newValue) {
                    var severityColumnIdx = columnsHelper.getIdxByIdStrict($scope.options.columns, 'severity');
                    if (severityColumnIdx === -1) {
                        return false;
                    }
                    var found = _($scope.tableModel.data).find(function (row) {
                        return row[primaryColumn].originalText === eventId;
                    });
                    if (!found) {
                        return false;
                    }
                    found[severityColumnIdx].originalText = newValue;
                    found[severityColumnIdx].text = securityEventsConverters.severityConverter(newValue, 'severity', { id: eventId }, $scope.options.columns[severityColumnIdx].converterArgs);
                    return true;
                }
                $scope.$on('security-event-severity-change', function (event, data) {
                    if (data.oldValue === data.newValue) {
                        return;
                    }
                    if (!updateVisualSeverity(data.attributes.eventId, data.newValue)) {
                        return;
                    }
                    securityEventsDao.update(data.attributes.eventId, {
                        severity: data.newValue,
                        aggregation_id: data.attributes.aggregation_id
                    }).then(function (response) {
                        return updateEventInline(response);
                    }).then(function () {
                        $scope.secEventsApi.reload({ charts: true });
                    }, function (error) {
                        reloadSecEventsApi();
                    });
                });
                $scope.$on('event-action', function (event, data) {
                    if (data.action.config_missing && data.action.config_missing.length) {
                        return modals.confirm({
                            title: 'Invalid configuration',
                            message: data.action.config_error_message || 'Configuration parameters required to run this actions are not set correctly.',
                            okText: 'Configure',
                            cancelText: 'Cancel'
                        }).then(function () {
                            return appConfigurator.configureApp(data.action.config_module);
                        }).then(function () {
                            reloadSecEventsApi();
                        }, _.noop);
                    }
                    performSelectedChildrenOnParentAction(data.eventId, data.actionId, data);
                });
                $scope.$on('download-entity', function (event, data) {
                    return downloadDetectedEntity.download(data.entityType, data.entityId);
                });
                $scope.$on('add-security-event-exception', function (event, data) {
                    // if the primary id is dummy id, please fix it to real id
                    if (data.eventId && data.eventId.indexOf('_parent') !== -1) {
                        data.eventId = data.eventId.slice(0, -7);
                        if (data.eventData && data.eventData.sec_event_id) {
                            data.eventData.sec_event_id = data.eventId;
                        }
                    }
                    var p = $q.when();
                    var exceptionParams = {
                        security_event_id: data.eventId,
                        // deprecated, it will be removed later
                        sec_event_id: data.eventId,
                        exception_type: data.exceptionType
                    };
                    if (data.params && data.params.length) {
                        var dialogParams = [];
                        _(data.params).each(function (param) {
                            if (param.data.length === 1) {
                                exceptionParams[param.param] = param.data[0];
                            } else {
                                dialogParams.push({
                                    id: param.param,
                                    label: param.label,
                                    type: 'selector',
                                    variants: param.data,
                                    data: param.data[0]
                                });
                            }
                        });
                        if (dialogParams.length) {
                            p = modals.params([{
                                    lastPage: true,
                                    params: dialogParams
                                }], 'Allow-List ' + data.exceptionLabel).then(function (data) {
                                $.extend(exceptionParams, data);
                            });
                        }
                    }
                    p.then(function () {
                        if (!(data && data.eventData && data.eventData.aggregation_id)) {
                            eventsUpdating[data.eventId] = true;
                            updateRowClasses();
                        }
                        return securityEventsDao.addException(exceptionParams).then(function (response) {
                            return updateEventInline(response);
                        }).finally(function () {
                            if (data && data.eventData && data.eventData.aggregation_id) {
                                $scope.widgetApi.reload();
                                return;
                            }
                            eventsUpdating[data.eventId] = false;
                            updateRowClasses();
                        });
                    });
                });
                $scope.$on('add-avanan-ap-exception', function (event, data) {
                    // if the primary id is dummy id, please fix it to real id
                    if (data.eventId && data.eventId.indexOf('_parent') !== -1) {
                        data.eventId = data.eventId.slice(0, -7);
                        if (data.eventData && data.eventData.sec_event_id) {
                            data.eventData.sec_event_id = data.eventId;
                        }
                    }
                    return apExceptionsModal.show({
                        entityType: data.entityType,
                        entityId: data.entityId,
                        type: 'whitelist',
                        loadFn: function () {
                            if (!(data && data.eventData && data.eventData.aggregation_id)) {
                                eventsUpdating[data.eventId] = true;
                                updateRowClasses();
                            }
                        },
                        afterLoadFn: function () {
                            modals.alert('Processing... This may take up to 10 minutes.', { title: ' ' });
                            if (data && data.eventData && data.eventData.aggregation_id) {
                                $scope.widgetApi.reload();
                                return;
                            }
                            eventsUpdating[data.eventId] = false;
                            updateRowClasses();
                        }
                    });
                });
                $scope.$on('add-anomaly-exception', function (event, data) {
                    var p = $q.when();
                    var exceptionTitle = data.eventData.event_metadata.metadata_json.title ? data.eventData.event_metadata.metadata_json.title : 'Add Allow-List option';
                    var exceptionParams = [];
                    var kafka_callback = data.eventData.event_metadata.metadata_json.kafka_callback_info;
                    var saveData = {
                        id: data.eventData.event_metadata.metadata_json.id,
                        event_id: data.eventId,
                        kafka_callback_info: kafka_callback
                    };
                    if (data.eventData.sec_event_id) {
                        exceptionParams.push({
                            id: 'event_id',
                            data: data.eventData.sec_event_id
                        });
                    }
                    _(data.eventData.event_metadata.metadata_json.columns).each(function (param) {
                        if (param.type === 'selector-v2') {
                            // this is not allowed any empty field on clicking OK.
                            var defaultData = param.data;
                            if (!param.data && param.variants && param.variants.length) {
                                if (_(param.variants[0]).isObject() && param.variants[0].id) {
                                    defaultData = param.variants[0].id;
                                } else if (_(param.variants[0]).isString()) {
                                    defaultData = param.variants[0];
                                }
                            }
                            exceptionParams.push({
                                id: param.id,
                                label: param.label,
                                type: param.type,
                                variants: param.variants,
                                data: defaultData,
                                labelClass: 'custom-width',
                                paramClass: 'custom-width'
                            });
                        } else {
                            exceptionParams.push(param);
                        }
                    });
                    if (exceptionParams.length) {
                        p = modals.params([{
                                lastPage: true,
                                params: exceptionParams
                            }], exceptionTitle, data.eventData.event_metadata.dialogWidth ? data.eventData.event_metadata.dialogWidth : 'md', { windowClass: 'anomaly-exception-modal-container' }).then(function (newData) {
                            $.extend(saveData, newData);
                        });
                    }
                    p.then(function () {
                        return anomalyExceptionsParams.saveException(saveData).then(function () {
                            $scope.widgetApi.reload();
                        });
                    });
                });
                // secToolExceptionListener
                $scope.$on('add-sec-tool-exception', function (event, data) {
                    var localEntity = entityTypes.toLocal(data.entityType);
                    modals.confirm({
                        message: 'Are you sure you want to add this ' + (localEntity === 'email' ? 'message' : localEntity) + ' to ' + secToolsExceptionParams.getLabel(data.secType) + '?',
                        title: 'Add Security Tools Exception',
                        okText: 'Add exception'
                    }).then(function () {
                        return fileDao.exceptionsAdd([{
                                entity_type: data.entityType,
                                entity_id: data.entityId,
                                sec_type: data.secType
                            }]);
                    }).then(function () {
                        $scope.widgetApi.reload();
                    });
                });
                function updateRowClasses() {
                    if (!$scope.tableModel || !$scope.tableModel.data) {
                        return;
                    }
                    _($scope.tableModel.data).each(function (row, idx) {
                        $scope.tableModel.rowClasses[idx] = $scope.tableModel.rowClasses[idx] || {};
                        if (eventsUpdating[row[primaryColumn].originalText]) {
                            $scope.tableModel.rowClasses[idx].processing = true;
                        } else {
                            delete $scope.tableModel.rowClasses[idx].processing;
                        }
                        delete $scope.tableModel.rowClasses[idx]['highlighted-event'];
                        if (highlightEvent && row[primaryColumn].originalText === highlightEvent) {
                            highlightEvent = false;
                            $scope.tableModel.rowClasses[idx]['highlighted-event'] = true;
                            $timeout(function () {
                                var hRow = $('.highlighted-event');
                                if (hRow.length) {
                                    hRow[0].scrollIntoView();
                                }
                            });
                        }
                    });
                }
                $scope.$on('$gotViewReportLinks', function (event, data) {
                    if (!$scope.tableModel || !$scope.tableModel.data) {
                        return;
                    }
                    var entityIdIdx = columnsHelper.getIdxByIdStrict($scope.options.columns, 'entity_id');
                    var foundRowIndex = _($scope.tableModel.data).findIndex(function (row) {
                        return row[entityIdIdx].originalText === data.entityId;
                    });
                    if (foundRowIndex !== -1) {
                        var targetColumn = $scope.tableModel.idToColumn['_resolved.available_actions'];
                        if (targetColumn && targetColumn.idx) {
                            var oldData = $scope.tableModel.data[foundRowIndex][targetColumn.idx].text;
                            $scope.tableModel.data[foundRowIndex][targetColumn.idx].text = oldData + data.links;
                        }
                    }
                });
                $scope.$on('orderingChange', function (event, sort) {
                    $scope.searchAfter = undefined;
                });
                $scope.widgetApi = $scope.widgetApi || {};
                $scope.widgetApi.reload = function () {
                    if (!$scope.tableHelper) {
                        return;
                    }
                    eventsUpdating = {};
                    aggregatedData = {};
                    availableActionsMap = {};
                    $scope.filterActions = [];
                    totalRowsTimeout = undefined;
                    $scope.searchAfter = undefined;
                    $scope.tableHelper.clearSelection();
                    $scope.tableHelper.reload();
                };
                function addTitle(event) {
                    if (event.currentTarget.offsetWidth < event.currentTarget.scrollWidth) {
                        if (!event.currentTarget.getAttribute('title')) {
                            event.currentTarget.setAttribute('title', event.currentTarget.textContent);
                        }
                    }
                }
                var filterByControl = element.find('input.filter-by');
                function onDocumentKeyPress(event) {
                    if (event.target && event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA' && filterByControl.length) {
                        $scope.filterBy += String.fromCharCode(event.which);
                        $timeout(function () {
                            filterByControl.focus();
                        });
                    }
                }
                $(document).on('mouseenter', '.security-events-tip-value', addTitle);
                $(document).on('keypress', onDocumentKeyPress);
                $scope.$on('$destroy', function () {
                    $(document).off('mouseenter', '.security-events-tip-value', addTitle);
                    $(document).off('keypress', onDocumentKeyPress);
                });
            }
        };
    }]);
}());